export const GET_FAILRECORDS = {
  BEGIN: 'GET_FAILRECORDS_BEGIN',
  SUCCESS: 'GET_FAILRECORDS_SUCCESS',
  FAILURE: 'GET_FAILRECORDS_FAILURE'
}
